import user from 'js/lib/user';

import { useProductFeatures } from 'bundles/employability-common/feature-flags/productFeatureFlags';
import { IdTypes } from 'bundles/product-features';

export const useRestrictHiringSolutions = () => {
  const userId = String(user.get().id ?? '');
  const loggedIn = user.isAuthenticatedUser();

  const { features } = useProductFeatures({
    idType: IdTypes.User,
    id: userId,
    ssr: true,
  });

  if (!loggedIn) {
    return {
      restrictHiringSolutions: false,
    };
  }

  return {
    restrictHiringSolutions: features.get('enterprise', 'restrictHiringSolutions'),
  };
};
